








import { defineComponent, computed, getCurrentInstance } from "vue";

export default defineComponent({
  setup() {
    const root = getCurrentInstance();
    const collaboration = computed(() => root.proxy.$store.state.collaboration);
    const isChecked = computed({
      get: () => collaboration.value.isBatchSelected,
      set: val => {
        if (val) {
          root.proxy.$store.dispatch("collaboration/selectVisibleEvents");
        } else {
          root.proxy.$store.dispatch("collaboration/unselectVisibleEvents");
        }
        root.proxy.$store.commit("collaboration/toggleBatch");
      }
    });
    return { isChecked };
  }
});
